import React from 'react'
import { array } from 'prop-types'
import intl from 'react-intl-universal'

import Typography from 'components/atoms/Typography'
import FacultyItem from 'components/molecules/FacultyItem'

const FacultiesList = ({ faculties }) => (
  <div className="school-faculties__list">
    {
      faculties.length > 0 ?
        faculties.map(faculty => <FacultyItem {...faculty} key={`fitm-${faculty.id}`}/>) :
        <div className="school-faculties__not-found">
          <Typography component="p" variant="subheadline" className="text-center">
            {intl.get('school_faculties.not_found')}
          </Typography>
        </div>
    }
    <style jsx>
      {`
        .school-faculties__not-found {
          padding: 2em 0;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }
      `}
    </style>
  </div>
)

FacultiesList.propTypes = {
  faculties: array,
}

export default FacultiesList
